import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowTopRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-arrow-top-right, open, new, link, open link, box, arrow"} maskId="square-filled-radius-0-stroke-1-IconSquareArrowTopRight"><path fillRule="evenodd" clipRule="evenodd" d="M14 3H21V10H20V4.70711L11.5 13.2071L10.7929 12.5L19.2929 4H14V3ZM3 5H11V6H4V20H18V13H19V21H3V5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareArrowTopRight;
